import type {
    GenericVuetifyListItem
} from 'x1-base/types';

export const GenderListMinimum: GenericVuetifyListItem[] = [
    {
        title: 'Male',
        value: 'M'
    },
    {
        title: 'Female',
        value: 'F'
    }
];
